var map = {
	"./accounts-room.jpg": 77,
	"./accounts-team.jpg": 78,
	"./case-cockpit.jpg": 79,
	"./case-final-exam.jpg": 80,
	"./case-meeting-rooms.jpg": 81,
	"./case-norwegian-1.jpg": 82,
	"./case-norwegian-2.jpg": 83,
	"./case-novair.jpg": 84,
	"./case-pelesys-1.jpg": 85,
	"./case-pelesys-2.jpg": 86,
	"./case-realestate.jpg": 87,
	"./case-yachts.jpg": 88,
	"./coffee-machine.jpg": 89,
	"./learn-test-export.jpg": 90,
	"./mountains-big.jpg": 91,
	"./mountains-small-taggis.jpg": 92,
	"./mountains-small.jpg": 93,
	"./new-laptop.jpg": 40,
	"./taggis-and-docbrowser.jpg": 94,
	"./taggis-brochure.jpg": 41,
	"./trial-mac.jpg": 95,
	"./upload-visuals-old.jpg": 96,
	"./video-see-how.jpg": 97,
	"./video-watch-taggis.jpg": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 315;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 315
// module chunks = 3